
        Component.define('products-list', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

$('.products').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$window
    .on('resize', function () {
        if (wW < 769) {
            if (slickIndex) {
                $('.products').slick('slickGoTo', slickIndex);
            }
        }
});

        });